import getAuthorizedLpsEpic from './getAuthorizedLpsEpic';
import getLpSelectedEpic from './getLpSelectedEpic';
import getAuthorizedEntitiesEpic from './getAuthhorizedEntitiesEpic';

export const lpEpics = [
  getAuthorizedLpsEpic,
  getAuthorizedEntitiesEpic,
  getLpSelectedEpic,
];

export default lpEpics;
